import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/next-core/next-core/workspaces/core/src/components/Elastic/ElasticClientInstrumentation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/next-core/next-core/workspaces/core/src/components/Login/Wrapper.tsx");
